import React from 'react'
import ReactDOM from 'react-dom/client'
import App from './App.tsx'
import ErrorBoundary from './components/ErrorBoundary'
import { initSentry } from './lib/sentry'
import './styles/index.css'

// Initialize Sentry before rendering the app
initSentry();

// Suppress browser extension errors that don't affect our app
window.addEventListener('unhandledrejection', (event) => {
  // Ignore errors from browser extensions
  if (event.reason?.message?.includes('message channel closed')) {
    console.warn('[Suppressed] Browser extension error:', event.reason.message);
    event.preventDefault();
  }
});

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <ErrorBoundary>
      <App />
    </ErrorBoundary>
  </React.StrictMode>,
)

